<template>
  <div class="maindrum">
    <svg style="margin-left: 46%;margin: 10px auto 10px auto;" height="30" viewBox="0 0 512 512" width="30" xmlns="http://www.w3.org/2000/svg"><g id="Flat"><rect fill="#5540b0" height="384" rx="24" width="288" x="152" y="24"/><path d="m384 376h-176a24 24 0 0 0 -24-24v-272a24 24 0 0 0 24-24h176a24 24 0 0 0 24 24v272a24 24 0 0 0 -24 24z" fill="#bc4598"/><rect fill="#5f4bbc" height="384" rx="24" width="288" x="56" y="104"/><path d="m112 136h176a24 24 0 0 0 24 24v272a24 24 0 0 0 -24 24h-176a24 24 0 0 0 -24-24v-272a24 24 0 0 0 24-24z" fill="#bc4598"/><path d="m235.672 302.776 44.328-14.776-44.328-14.776 28.328-49.224-49.224 28.328-14.776-76.328-14.776 76.328-49.224-28.328 28.328 49.224-44.328 14.776 44.328 14.776-28.328 49.224 49.224-28.328 14.776 76.328 14.776-76.328 49.224 28.328z" fill="#ffba40"/><g fill="#f2951b"><path d="m112 176h16v16h-16z"/><path d="m112 248h16v16h-16z"/><path d="m152 192h16v16h-16z"/><path d="m272 192h16v16h-16z"/><path d="m112 376h16v16h-16z"/><path d="m160 400h16v16h-16z"/><path d="m280 376h16v16h-16z"/><path d="m232 416h16v16h-16z"/><path d="m272 248h16v16h-16z"/><path d="m232 168h16v16h-16z"/></g></g></svg>
    <h1 style="font-weight:500;font-size: 2rem;margin-bottom: 10px;">
      MYSTERY CARDS
    </h1>
    <h3 style="margin: auto 1rem auto 1rem;">
      Pick a card to reveal a special reward
    </h3>
    <div class="maincontainer" v-if="boxes">
      <box v-for="(box,index) in boxes"  :index="index"/>
    </div>
    <div v-else style="display: flex;align-items: center;justify-content: center;">
      <p>
        Loading, please wait...
      </p>
    </div>
    <transition v-if="isModalVisible" name="modal-fade">
      <div class="modal-backdrop">
        <div class="modal"
             role="dialog"
             aria-labelledby="modalTitle"
             aria-describedby="modalDescription"
        >
          <section
              class="modal-body"
              id="modalDescription"
          >
            <slot name="body">
              {{message}}
            </slot>
            <div class="container" v-if="over">
              <div class="shape shape-1"></div>
              <div class="shape shape-2"></div>
              <div class="shape shape-3"></div>
              <div class="shape shape-4"></div>
            </div>
          </section>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";

const path = require('../../public/celebrate.mp3');
import modal from './Modal'
import Box from './Boxes'
export default {
  components:{
    modal,
    Box
  },
  data() {
    return {
      isModalVisible: false,
      over:false,
      boxes:[],
      message:null,
      audio:[
        {
          id: 'celebrate',
          name: 'Celebration',
          file: new Audio(path),
          isPlaying: false
        }
      ]
    };
  },
  mounted()
  {
    this.getPrizes();
  },
  computed:{

  },
  methods: {
    getPrizes()
    {
      let context = this;
      const api = "https://create.tuni.ke/api/reward/mystery/cards";
      const qs = require('qs')
      axios({
        method: 'post',
        url: api,
        data: qs.stringify({
          'trivia_id': this.$store.state.matchSlug,
          'player_id': this.$store.state.scores.playerOne.id,
          'isp':this.$store.state.isp
        }),
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }).then(response => {
        context.boxes = response.data.data;
        this.options();
        console.log("response.data");
        console.log(response.data)
      })
    },
    options(){
      let i = this.boxes.length, temp, rand;
      while (0 !== i) {
        rand = Math.floor(Math.random() * i);
        i -= 1;
        temp = this.boxes[i];
        this.boxes[i] = this.boxes[rand];
        this.boxes[rand] = temp;
      }
    },
    advance() {
      if (this.$store.state.round <= (this.$store.state.questions.length)) {
        console.log("set isOnBreak to false")
        this.$store.commit('pauseGame');
        this.$store.commit('incrementRound');
        this.$store.commit('playerClickedCard',false);
        this.$store.commit('setResults',false);
        // this.$store.commit('pauseGame');
        // //this.playerClickedCard = false;
        // this.$store.commit('playerClickedCard',false);
        // //this.resultsView = false;
        // this.$store.commit('setResults',false);
        //this.timerCount = 30;
        setTimeout(() => {
          this.$store.commit('setMystery');
        }, 1500)
      }else
      {
        //this.$store.commit('isGameOver');
        setTimeout(() => {
          this.$store.commit('setMystery');
        }, 1500)

      }
    },
    showModal(key) {
      let context = this;
      this.message = this.boxes[key];
      this.isModalVisible = true;
      this.over = true;
      this.audio[0].file.play();
      setTimeout(() => {
        if (this.over)
        {
          console.log("gane over");
          context.advance();
          // if (key===0)
          // {
          //
          // }
          // if (key === 1)
          // {
          //
          // }
          // if (key===2)
          // {
          //
          // }
        }
      }, 3000)
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
};
</script>

<style lang="sass" scoped>
/* THE MAINCONTAINER HOLDS EVERYTHING
h1
  font-weight: bolder
  font-size: 4rem
  color: #2a3580
  text-align: center
h2, h3, h4,h5,h6
  font-weight: 400
  text-align: center
  font-size: 1rem
  color: #2a3580
.maindrum
  justify-content: center
  display: grid
  grid-template-rows: min-content min-content min-content minmax(100px,420px)
.maincontainer
  display: grid
  grid-template-columns: 1fr 1fr
  grid-template-rows: 1fr 1fr
  gap: 1rem
  margin: 1rem
  background: none
  justify-content: center
/* THE CARD HOLDS THE FRONT AND BACK FACES

.modal-backdrop
  position: fixed
  top: 0
  bottom: 0
  left: 0
  right: 0
  background-color: rgba(0, 0, 0, 0.3)
  display: flex
  justify-content: center
  align-items: center

.modal
  background: #FFFFFF
  box-shadow: 2px 2px 20px 1px
  overflow-x: auto
  display: flex
  width: 100%
  text-align: center
  justify-content: center
  min-height: 130px
  flex-direction: column

.modal-header, .modal-footer
  padding: 15px
  display: flex

.modal-header
  border-bottom: 1px solid #eeeeee
  color: #4AAE9B
  justify-content: space-between

.modal-footer
  border-top: 1px solid #eeeeee
  justify-content: flex-end

.modal-body
  position: relative
  padding: 20px 10px

.btn-close
  border: none
  font-size: 20px
  padding: 20px
  cursor: pointer
  font-weight: bold
  color: #4AAE9B
  background: transparent

.btn-green
  color: white
  background: #4AAE9B
  border: 1px solid #4AAE9B
  border-radius: 2px

// Colors variables
$primary: #4285F4

// blue
$success: #34A853

// green
$danger: #EA4335

// red
$warning: #FBBC05
$containerDimentions: 30px
$shapeDimentions: 10px
$amount: 20px

html, body
  margin: 0
  width: 100%
  height: 100%
  background-color: #03002E

body
  display: flex
  justify-content: center
  align-items: center

*
  box-sizing: border-box
.container
  position: absolute
  top: 50%
  left: 50%
  z-index: 999
  width: $containerDimentions
  height: $containerDimentions
  border-radius: $containerDimentions / 2
  animation: rotation 1s infinite

  .shape
    position: absolute
    width: $shapeDimentions
    height: $shapeDimentions
    border-radius: $shapeDimentions / 2

    &.shape-1
      left: 0
      background-color: $primary

    &.shape-2
      right: 0
      background-color: $success

    &.shape-3
      bottom: 0
      background-color: $warning

    &.shape-4
      bottom: 0
      right: 0
      background-color: $danger

  @for $i from 1 through 4
    .shape-#{$i}
      animation: shape#{$i} 0.5s infinite alternate

@keyframes rotation
  from
    transform: rotate(0deg)

  to
    transform: rotate(360deg)

=shapeTranslate($index, $tx, $ty)
  @keyframes shape#{$index}
    from
      transform: translate(0, 0)

    to
      transform: translate($tx, $ty)

+shapeTranslate(1, $amount, $amount)
+shapeTranslate(2, -$amount, $amount)
+shapeTranslate(3, $amount, -$amount)
+shapeTranslate(4, -$amount, -$amount)
</style>
